import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
@Component({
  selector: 'app-modal-imagem-perfil',
  templateUrl: './modal-imagem-perfil.component.html',
  styleUrls: ['./modal-imagem-perfil.component.css']
})
export class ModalImagemPerfilComponent {
  croppedBlob: any;
  croppedImage: any = '';
  imageBase64: any = '';
  imageChangedEvent: any = '';
  result: any;
  constructor(public activeModal: NgbActiveModal, private userService: UsuarioService, private sanitizer: DomSanitizer, private toast: ToastrService) { }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  };
  async fileChangeEvent(event: any): Promise<void> {
    this.imageBase64 = await toBase64(event.addedFiles[0]);
  };
  evento() {
    this.toast.error('Upload apenas de imagens!');
    this.activeModal.dismiss('Cross click');
  }
  changeImg() {
    this.userService.updateUserImg(this.croppedImage).subscribe(() => {
      this.activeModal.dismiss('Cross click');
      location.reload();
    });
  }
}
const toBase64 = (file: File) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});